import {
  postRequest,
  getRequest,
  patchRequest,
  deleteRequest,
} from "../../axios/axios";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const createTask = createAsyncThunk("tasks/createTask", async (data) => {
  try {
    const token = localStorage.getItem("token");

    const res = await postRequest("/api/v1/tasks", token, data);

    if (res.data.status === "success") return res.data.data.task;
  } catch (err) {
    throw err.response ? err.response.data.message : err.message;
  }
});

export const fetchTasks = createAsyncThunk("tasks/fetchTasks", async (data) => {
  try {
    const token = localStorage.getItem("token");

    const res = await getRequest("/api/v1/tasks", token, data);

    if (res.data.status === "success") return res.data.data;
  } catch (err) {
    throw new Error(err.response ? err.response.data.message : err.message);
  }
});

export const updateTask = createAsyncThunk(
  "tasks/updateTask",
  async ({ id, status, ...data }) => {
    try {
      const payload = Object.keys(data).length ? data : { status };

      const token = localStorage.getItem("token");

      const res = await patchRequest(`/api/v1/tasks/${id}`, payload, token);

      if (res.data.status === "success") {
        return { id, data: res.data.data.task, status };
      }
    } catch (err) {
      throw err.response ? err.response.data.message : err.message;
    }
  }
);

export const deleteTask = createAsyncThunk(
  "tasks/deleteTask",
  async ({ id, status }) => {
    try {
      const token = localStorage.getItem("token");

      const res = await deleteRequest(`/api/v1/tasks/${id}`, token);

      if (res.status === 204) {
        return { id, status };
      }
    } catch (err) {
      throw err.response ? err.response.data.message : err;
    }
  }
);

export const createSubtask = createAsyncThunk(
  "tasks/createSubtask",
  async (data) => {
    try {
      const { task, index, ...payload } = data;

      const token = localStorage.getItem("token");

      const res = await postRequest(
        `/api/v1/tasks/${task}/subtasks`,
        token,
        payload
      );

      if (res.data.status === "success")
        return { index, data: res.data.data.subTask };
    } catch (err) {
      throw err.response ? err.response.data.message : err.message;
    }
  }
);

export const updateSubtask = createAsyncThunk(
  "tasks/updateSubtask",
  async ({ task: taskId, id: subtaskId, status, index, ...data }) => {
    try {
      const token = localStorage.getItem("token");

      const res = await patchRequest(
        `/api/v1/tasks/${taskId}/subtasks/${subtaskId}`,
        data,
        token
      );

      if (res.data.status === "success") {
        return { index, data: res.data.data.subTask };
      }
    } catch (err) {
      throw err.response ? err.response.data.message : err.message;
    }
  }
);

export const deleteSubtask = createAsyncThunk(
  "tasks/deleteSubtask",
  async ({ id: subtaskId, status, taskId, index }) => {
    try {
      const token = localStorage.getItem("token");

      const res = await deleteRequest(
        `/api/v1/tasks/${taskId}/subtasks/${subtaskId}`,
        token
      );

      if (res.status === 204) {
        return { taskId, status, subtaskId, index };
      }
    } catch (err) {
      throw err.response ? err.response.data.message : err;
    }
  }
);

export const createTaskFromSubtask = createAsyncThunk(
  "tasks/createTaskFromSubtask",
  async ({ subtaskId, index, newStatus, oldStatus }) => {
    try {
      const token = localStorage.getItem("token");

      const { data } = await postRequest(
        `/api/v1/subtasks/${subtaskId}/promote`,
        token,
        { status: newStatus }
      );

      if (data.status === "success") {
        return { data: data.data.task, index, oldStatus };
      }
    } catch (err) {
      throw err.response ? err.response.data.message : err.message;
    }
  }
);

export const updateTasksOrder = createAsyncThunk(
  "tasks/updateTasksOrder",
  async ({ status, taskIds }) => {
    try {
      const token = localStorage.getItem("token");
      await patchRequest(`/api/v1/tasks/${status}/reorder`, { taskIds }, token);
    } catch (err) {
      throw new Error(err.response ? err.response.data.message : err.message);
    }
  }
);

export const moveTaskBetweenLists = createAsyncThunk(
  "tasks/reOrders",
  async ({ from, to, sourceTasks, destinationTasks, taskId }, { dispatch }) => {
    try {
      dispatch(updateTask({ id: taskId, status: to }));

      return { from, to, sourceTasks, destinationTasks };
    } catch (err) {
      throw new Error(err.response ? err.response.data.message : err.message);
    }
  }
);
